import React from "react";

import { Dot } from "../../../common/Dot/dot";
import { ensureHexValue } from "../../../common/utils";
import AnalyticCard, { DEFAULT_ERROR_MESSAGE } from "../AnalyticCard/AnalyticCard";
import {
  StyledProgress,
  Column,
  Main,
  StateLabel,
  StateProgress,
  TaskCount
} from "../common/styledComponents";

import { StateStatistic, useOpenStateTaskStatistics } from "./queries";

export function OpenStateTaskStatisticsView({
  stateStatistics,
  className
}: {
  stateStatistics: StateStatistic[];
  className?: string;
}) {
  const totalTaskCount = stateStatistics.reduce((prev, current) => {
    return prev + current.taskCount;
  }, 0);

  return (
    <Main className={className}>
      <Column>
        {stateStatistics.map(stat => (
          <StateLabel key={`${stat.state.id}-label`}>
            <Dot color={ensureHexValue(stat.state.color)} />
            {stat.state.name}
          </StateLabel>
        ))}
      </Column>
      <Column>
        {stateStatistics.map(stat => (
          <TaskCount key={`${stat.state.id}-count`}>{stat.taskCount}</TaskCount>
        ))}
      </Column>
      <StateProgress>
        {stateStatistics.map(stat => (
          <StyledProgress
            key={`${stat.state.id}-progress`}
            strokeWidth={10}
            strokeColor={ensureHexValue(stat.state.color)}
            percent={(stat.taskCount / totalTaskCount) * 100}
            showInfo={false}
          />
        ))}
      </StateProgress>
    </Main>
  );
}

export default function OpenStateTaskStatistics({
  queueId,
  className
}: {
  queueId?: string;
  className?: string;
}) {
  const { data, loading, error } = useOpenStateTaskStatistics({
    variables: { queueId: queueId! },
    skip: !queueId,
    fetchPolicy: "cache-and-network"
  });

  return (
    <AnalyticCard
      title="Current open tasks"
      loading={loading}
      errorMessage={error ? DEFAULT_ERROR_MESSAGE : undefined}
      className={className}
    >
      <OpenStateTaskStatisticsView
        stateStatistics={data?.openStateTaskStatistics || []}
      />
    </AnalyticCard>
  );
}
